import React from 'react';


const Dummy = () => {
    return (
        <main />
    )
}

export default Dummy;